import { hasConsent, gtagEvent } from "@/lib/consent";

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/track`;

const GA = {
  search: (d) => ["search", { search_term: d.q }],
  profile: (d) => ["view_item", { item_id: d.lid, item_category: d.cat }],
  contact: (d) => ["generate_lead", { method: d.ch, item_id: d.lid }],
  ad_view: (d) => ["view_promotion", { promotion_id: d.ad }],
  ad_click: (d) => ["ad_click", { ad_id: d.ad, ad_placement: d.cat || "" }],
  login: () => ["login", {}],
  signup: () => ["sign_up", { method: "email" }],
  listing_create: (d) => ["business_listing_created", { listing_category: d.cat, listing_id: d.lid }],
};

// First-party stats + GA4 event; does nothing without analytics consent
export function track(t, data = {}) {
  if (!hasConsent("analytics")) return;
  if (t === "listing_create") { gtagEvent(...GA[t](data)); return; }
  const body = JSON.stringify({ t, path: window.location.pathname, ...data });
  if (navigator.sendBeacon) navigator.sendBeacon(URL, new Blob([body], { type: "text/plain" }));
  else fetch(URL, { method: "POST", body, keepalive: true }).catch(() => {});
  if (GA[t]) gtagEvent(...GA[t](data));
}

export function trafficSource() {
  const p = new URLSearchParams(window.location.search);
  const med = (p.get("utm_medium") || "").toLowerCase();
  if (p.get("gclid") || /cpc|ppc|paid|ads/.test(med)) return "paid";
  if (/social/.test(med)) return "social";
  const ref = document.referrer;
  if (!ref) return p.get("utm_source") ? "referral" : "direct";
  let h = "";
  try { h = new window.URL(ref).hostname; } catch { return "direct"; }
  if (h === window.location.hostname) return "direct";
  if (/google\.|bing\.|duckduckgo|yahoo\.|ecosia|yandex|baidu|startpage|qwant/.test(h)) return "organic";
  if (/facebook|fb\.|instagram|t\.co|twitter|x\.com|tiktok|linkedin|youtube|whatsapp|viber|telegram|snapchat|pinterest|reddit/.test(h)) return "social";
  return "referral";
}
